import { render, staticRenderFns } from "./Pests.html?vue&type=template&id=8f3fe608&external"
import script from "./Pests.js?vue&type=script&lang=js&external"
export * from "./Pests.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports